<template>
  <v-form ref="form" lazy-validation>
    <v-container>
      <v-layout column>
        <v-card>
          <v-card-text>
            <v-text-field
              prepend-icon="mdi-account"
              v-model="user.first_name"
              :label="$t('profile.first-name')"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-account"
              v-model="user.last_name"
              :label="$t('profile.last-name')"
            ></v-text-field>
            <v-text-field
              prepend-icon="email"
              v-model="user.email"
              label="Email"
              disabled
            ></v-text-field>
            <v-text-field
              prepend-icon="year"
              v-model="user.year"
              :label="$t('profile.year')"
            ></v-text-field>
            <v-text-field
              prepend-icon="lock"
              v-model="user.role"
              label="Role"
              disabled
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="editUserProfile">
              <v-icon left dark>check</v-icon>
              {{ $t("profile.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from "vuex"
import { USER_ME_REQUEST } from "@/store/actions/user"
import { UPDATE } from "@/store/action-types"
import FormMixin from "@/mixins/FormMixin"
import pick from "lodash/pick"

export default {
  mixins: [FormMixin],
  computed: {
    user() {
      return this.$store.state.user.profile
    },
  },
  data() {
    return {
      show1: false,
      show2: false,
      password: "",
      passwordConfirmed: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length === 0 || v.length >= 8 || "Min 8 characters",
        confirm: () => this.password === this.passwordConfirmed,
      },
    }
  },
  async mounted() {
    if (this.$store.state.user.profile.length === 0) {
      await this.USER_ME_REQUEST()
    }
  },
  methods: {
    ...mapActions("user", [USER_ME_REQUEST, UPDATE]),
    editUserProfile() {
      if (!this.$refs.form.validate()) {
        this.$toast.warning(this.$t("errors.fill-missing-fields"))
        return
      }

      // TODO : Hack to create a copy of user to remove email property
      let newUser = JSON.parse(JSON.stringify(this.user))
      delete newUser.email
      delete newUser.role

      if (this.passwordConfirmed.length > 0) {
        newUser.password = this.passwordConfirmed
      }

      this.UPDATE(pick(newUser, ["first_name", "last_name", "password", "id"]))
        .then(
          () => {
            this.$toast.success(this.$t("success.edit-user-success"))
          },
          () => {
            this.$toast.warning(this.$t("errors.edit-user-fail"))
          }
        )
        .finally(() => {
          self.loading = false
        })
    },
  },
}
</script>
